import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import JavaScriptOutlinedSvg from "@ant-design/icons-svg/es/asn/JavaScriptOutlined";
import AntdIcon from "../components/AntdIcon";
var JavaScriptOutlined = function JavaScriptOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: JavaScriptOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  JavaScriptOutlined.displayName = 'JavaScriptOutlined';
}
export default /*#__PURE__*/React.forwardRef(JavaScriptOutlined);